var map = {
	"./game/ct_bru-plan.png": "ce43",
	"./game/schema/schema 1.svg": "d452",
	"./game/schema/schema 2.svg": "3d14",
	"./game/schema/schema 3 - DE.svg": "7e30",
	"./game/schema/schema 3 - EN.svg": "ff3f",
	"./game/schema/schema 3 - FR.svg": "ce3d",
	"./game/schema/schema 3 - NL.svg": "2e71",
	"./labels/critical_hut.png": "a4b8",
	"./labels/critical_hut.svg": "2520",
	"./labels/ct-bgg.png": "e5a2",
	"./labels/ct-facebook.png": "a8ff",
	"./labels/manufacturer_god.png": "20de",
	"./labels/manufacturer_god.svg": "1670",
	"./labels/translator_hubertrinner.png": "6d27",
	"./logo/logo_cmyk.png": "0393",
	"./logo/logo_rgb.png": "020d",
	"./photos/compositions/ct_bru-composition1.png": "50d9",
	"./photos/compositions/ct_bru-composition2.png": "d2dd",
	"./photos/product anatomy/ct_bru-anatomy.jpg": "19c1",
	"./photos/product anatomy/ct_bru-cards.png": "5fbb",
	"./photos/product profile/ct_bru-profile.png": "e6f6",
	"./photos/prototype/prototypes_overview.jpg": "3b81",
	"./roles/eric.svg": "eb56",
	"./roles/matthieu.svg": "192e",
	"./roles/steffen.svg": "9180",
	"./roles/thomas.svg": "74ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";